import React from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getRedirectPath, clearRedirectPath } from '@/utils/redirectPath';
import { useRouter } from 'next/router';
import useTheme from '@/theme/useTheme';
import CatchError from '@/components/system/CacthError';
import dynamic from 'next/dynamic';
import Loading from '@/components/ui/Loading';
import LocalizedLink from '@/components/ui/LocalizedLink';
import ParticleBackground from '@/components/ui/ParticleBackground';
import LoginCard from '@/components/system/Auth/LoginCard';

// Dynamically import components
const RegisterForm = dynamic(
  () => import('@/components/system/Auth/RegisterPage/RegisterForm'),
  {
    ssr: false,
    loading: () => <Loading size={120} />,
  },
);

// Register page component
const RegisterPage = () => {
  const { t } = useTranslation(['auth', 'common']);
  const { theme } = useTheme();
  const router = useRouter();

  const handleRegisterSuccess = () => {
    // Get the saved redirect path and clear it
    const redirectPath = getRedirectPath();
    clearRedirectPath();

    // Redirect to the saved path or home
    router.push(redirectPath);
  };

  return (
    <Box
      sx={{
        mt: { xs: 0, md: 6 },
        minHeight: '60vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <LoginCard mode="register">
        <RegisterForm onRegisterSuccess={handleRegisterSuccess} />
      </LoginCard>
    </Box>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'auth'])),
    },
  };
}

export default CatchError(RegisterPage);
